module.exports = __webpack_public_path__ + "6441eb17af0e7329d47114f595df82f2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/checkoutWidget/edit-icon.svg
// module id = pWE9
// module chunks = 446